import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './styles/index.less';
import { applyTheme } from './theme';

const params = new URLSearchParams(window.location.search);

// Extract functional params before passing the rest to theming
const currency = params.get('currency') ?? undefined;
const currencyOptions = params.get('currencyOptions') ?? undefined;
const amount = params.get('amount') ?? undefined;
const focusAmount = params.has('focusAmount');
const period = params.get('period') ?? undefined;
const locale = params.get('locale') ?? undefined;

params.delete('currency');
params.delete('currencyOptions');
params.delete('amount');
params.delete('focusAmount');
params.delete('period');
params.delete('locale');

applyTheme(params);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App
      currency={currency}
      currencyOptions={currencyOptions}
      amount={amount}
      focusAmount={focusAmount}
      period={period}
      locale={locale}
    />
  </React.StrictMode>
);
